module.exports = __webpack_public_path__ + "img/alpha-centauri.217829a7.jpg";